export default "__VITE_ASSET__1k1nVFVE__"